import React, { useContext, useState, useEffect } from "react";
import "./ProductPage.css";
import "swiper/swiper-bundle.css";
import "swiper/css/zoom";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, Zoom } from "swiper/modules";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faHeart, fas, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import Heart_Component from "../../../Common-Component/Heart_Component/Heart_Component";
import { Context } from "../../../../utils/context";
import { GlassMagnifier } from "react-image-magnifiers";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader_lottie from "../../../Animation/Loader_lottie/Loader_lottie";
import { ShimmerThumbnail } from "react-shimmer-effects";

library.add(fas);

const ProductPage = ({ product, selectedVariant, selectedsubVariant }) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSubImage, setSelectedSubImage] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const { IMG_URL, shimmerLoader } = useContext(Context);

  useEffect(() => {
    if (selectedVariant?.product_images) {
      setSelectedImage(selectedVariant?.product_images?.[0]?.image);
    }
  }, [selectedVariant]);

  useEffect(() => {
    if (selectedsubVariant?.product_multi_varient_images) {
      setSelectedImage(
        selectedsubVariant?.product_multi_varient_images?.[0]?.image
      );
    }
  }, [selectedsubVariant]);

  const handleImageClick = (imageSrc, index) => {
    setSelectedImage(imageSrc);
    setModalIndex(index);
  };

  const handleSubImageClick = (subimageSrc, index) => {
    setSelectedSubImage(subimageSrc);
    setSelectedImage("");
    setModalIndex(
      (selectedVariant?.product_images?.length || 0) + index // shift index for subVariant images
    );
  };

  // Collect all images in a single array
  const allImages = [
    ...(selectedVariant?.product_images?.map((img) => img?.image) || []),
    ...(selectedsubVariant?.product_multi_varient_images?.map(
      (img) => img?.image
    ) || []),
  ];

  return (
    <section className="cctv-innerpage mt-3">
      <div className="container-fluid">
        <div className="row camera-sec">
          <div className="col-12">
            {shimmerLoader ? (
              <ShimmerThumbnail rounded />
            ) : (
              // <div className="loader-container text-center my-5">
              //   <Loader_lottie />
              //   <p className="mt-2">Loading ...</p>
              // </div>
              <div className="card-sec">
                <Heart_Component
                  product={product}
                  variant={selectedVariant}
                  m_varient={selectedsubVariant}
                  handleShowModalClick={() => setShowModal(true)}
                />

                <div className="product-detail text-center">
                  {selectedImage || allImages.length > 0 ? (
                    <Swiper
                      slidesPerView={1}
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                      onSlideChange={(swiper) =>
                        setSelectedImage(allImages[swiper.activeIndex])
                      }
                      className="main-product-swiper">
                      {allImages.map((img, idx) => (
                        <SwiperSlide key={idx}>
                          <img
                            src={IMG_URL + img}
                            alt={`Product Slide ${idx + 1}`}
                            className="product-img"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <ShimmerThumbnail className="shimmerheight" rounded />
                  )}

                  {/* Thumbnail slider */}
                  <div className="thumbnail-slider mt-3">
                    {allImages.map((img, idx) => (
                      <img
                        key={idx}
                        src={IMG_URL + img}
                        alt={`Thumbnail ${idx + 1}`}
                        className={`thumbnail-img ${
                          selectedImage === img ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedImage(img);
                          if (swiperInstance) swiperInstance.slideTo(idx); // slide main Swiper to clicked image
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Thumbnails */}
          <div className="col-12">
            <div className="camera-slider">
              <Swiper
                slidesPerView={"auto"}
                modules={[Autoplay]}
                spaceBetween={20}
                breakpoints={{
                  0: { slidesPerView: 4, spaceBetween: 10 },
                  380: { slidesPerView: 4 },
                  485: { slidesPerView: 5 },
                  575: { slidesPerView: 4 },
                  768: { slidesPerView: 5 },
                  992: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                  1440: { slidesPerView: 7 },
                  2000: { slidesPerView: 7 },
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  loop: true,
                }}
                className="mySwiper">
                {allImages.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="camera-imgs"
                      onClick={() => {
                        setSelectedImage(img); // update main image state
                        if (swiperInstance) swiperInstance.slideTo(idx); // slide main Swiper
                      }}>
                      <img
                        src={IMG_URL + img}
                        className={`inner-img ${
                          selectedImage === img ? "active" : ""
                        }`}
                        alt={`Thumbnail ${idx + 1}`}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      {/* Modal with slider */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        className="image-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {currentSlide}/{allImages.length}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Swiper
            initialSlide={modalIndex}
            modules={[Navigation, Pagination, Zoom]}
            navigation
            pagination={{ clickable: true }}
            zoom={true} // ✅ zoom enabled
            className="modalSwiper"
            slidesPerView={1}
            onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex + 1)}>
            {allImages.map((img, idx) => (
              <SwiperSlide key={idx}>
                <div className="modal-image-wrapper  swiper-zoom-container text-center">
                  <img
                    src={IMG_URL + img}
                    alt={`slide-${idx}`}
                    className="modal-image"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ProductPage;
